import React from 'react';
import { ToastProvider } from '@/context/toast.context';

const withToast = (props) => {
  return <ToastProvider>{props.children}</ToastProvider>;
};

export default withToast;
